// attachments/useAttachment.js
import httpInjectorService from 'services/http-injector.service';

export const useAttachment = (context) => {
  
    const uploadAttachment = async (files = []) => {
    if (!files.length) return;

    const uploads = files.map((file) => {
      const formData = new FormData();

      Object.entries({ ...context, attachment: file }).forEach(
        ([key, value]) => {
          if (value !== null && value !== undefined) {
            formData.append(key, value);
          }
        }
      );

      return httpInjectorService.uploadAttachment(formData);
    });

    return Promise.all(uploads);
  };

  // get all attachments
  const fetchAttachments = async () => {
    return httpInjectorService.getAttachment(context);
  };

  // Delete attachment
  const deleteAttachment = async (attachment_id) => {
    return httpInjectorService.deleteAttachment({
      attachment_id,
      project_id: context.project_id,
    });
  };


  return {
    uploadAttachment,
    fetchAttachments,
    deleteAttachment,
  };
};
